export default __webpack_public_path__ + "static/media/SERAHMERCY SUIT - Product Management & Design and Software Development Support Person.3d029485.png";